module.exports = {", opens captions settings dialog":", abre el diálogo de configuración de subtítulos","Caption Settings Dialog":"Diálogo de configuración de subtítulos","Captions":"Subtítulos","captions off":"Subtítulos desactivados","captions settings":"configuración de subtítulos","Chat":"Chat","Chat messages":"Mensajes del chat","Session content":"Contenido de la sesión","Summary":"Resumen","Transcript":"Transcripción"}


//////////////////
// WEBPACK FOOTER
// ./src/videojs/lang/proeduca-es.json
// module id = aliT
// module chunks = 1